var HeadingComponent = /** @class */ (function () {
    function HeadingComponent() {
    }
    Object.defineProperty(HeadingComponent.prototype, "hostClassName", {
        get: function () { return 'heading'; },
        enumerable: true,
        configurable: true
    });
    return HeadingComponent;
}());
export { HeadingComponent };
